module.exports = __webpack_public_path__ + "static/media/article-image-2.1bc71066.jpg";